import { NgModule } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { LuxonDateAdapter } from './luxon-date-adapter';
import { IDIOMA } from 'src/app/app.config';

export const LUXON_DATE_FORMATS = {
    parse: {
        dateInput: 'dd/MM/yyyy',
    },
    display: {
        dateInput: 'dd/MM/yyyy',
        monthYearLabel: 'MMM yyyy',
        dateA11yLabel: 'dd/MM/yyyy',
        monthYearA11yLabel: 'MMMM yyyy',
    },
};

@NgModule({
    imports: [MatDatepickerModule],
    exports: [MatDatepickerModule],
    providers: [
        { provide: DateAdapter, useClass: LuxonDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: LUXON_DATE_FORMATS },
        { provide: MAT_DATE_LOCALE, useValue: IDIOMA },
    ],
})
export class MaterialConfigModule { }
